// src/pages/UserDeepDivePage/OrdersTable.tsx
import { Box } from '@mui/material'
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro'
import dayjs from 'dayjs'
import SectionContainer from '@components/SectionContainer'
import { UseDataSource } from '@hooks/useDataSource'
import CustomToolbar from '@components/CustomToolbar'

export type UserOrderRow = {
    id: string
    // source_id?: string | null
    title: string
    status: string
    createdAt: string | Date
}

interface OrdersTableProps {
    dataSource: UseDataSource
}

export default function OrdersTable({ dataSource }: OrdersTableProps) {
    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', flex: 1, sortable: true },
        {
            field: 'title',
            headerName: 'TITLE',
            type: 'string',
            flex: 1,
            sortable: true,
        },
        {
            field: 'status',
            headerName: 'STATUS',
            type: 'string',
            flex: 1,
            sortable: true,
        },
        {
            field: 'createdAt',
            headerName: 'CREATED',
            type: 'dateTime',
            flex: 1,
            sortable: true,
            valueFormatter: (value) =>
                value ? dayjs(value as string).format('YYYY/MM/DD HH:mm') : '',
        },
    ]

    return (
        <SectionContainer title="Orders">
            <Box sx={{ height: 360, width: '100%' }}>
                <DataGridPro
                    columns={columns}
                    disableRowSelectionOnClick
                    disableVirtualization
                    pagination
                    paginationMode="server"
                    filterMode="server"
                    sortingMode="server"
                    dataSource={dataSource.dataSource}
                    onFilterModelChange={(m) => dataSource.setFilterModel(m)}
                    pageSizeOptions={[5]}
                    hideFooterSelectedRowCount
                    showToolbar
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                    }}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            csvOptions: { fileName: 'orders' },
                            exportAllRows: dataSource.exportAllRows,
                            exporting: dataSource.exporting,
                            exportAs: 'csv',
                        },
                    }}
                    getRowId={(row) => row.id}
                />
            </Box>
        </SectionContainer>
    )
}
